module.exports = __webpack_public_path__ + "shell/assets/brand/federal/dark/rancher-logo.svg";